import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { debounceTime } from 'rxjs/operators';
import { formConstant } from '../../../../../config';
import { PageParams } from '../../../../core/models/page-params.model';
import { IPaginatorProperties } from '../../../../core/models/paginator.interface';
import { NotificationService } from '../../../../core/services/notification.service';
import { UserService } from '../../../../core/services/user.service';
import { ISubService } from '../../models/shipment-price.interface';
import { ShipmentPriceService } from '../../services/shipment-price.service';
import { ServiceComponent } from '../services/service/service.component';

@Component({
    selector: 'eci-sub-service',
    templateUrl: './sub-service.component.html',
    styleUrls: ['./sub-service.component.scss']
})
export class SubServiceComponent implements OnInit {

    @Input() serviceId: number;

    public currentSort: Sort;
    public pageParams: PageParams = new PageParams();
    public form: FormGroup;

    public displayedColumns = ['subServiceId', 'subServiceName'];
    public showLoader: boolean = false;
    public dataSource: MatTableDataSource<ISubService> = new MatTableDataSource<ISubService>([]);

    constructor(private userSvc: UserService,
                private dialog: MatDialog,
                private notify: NotificationService,
                private shipmentPriceSvc: ShipmentPriceService,
                private router: Router,
    ) {
    }

    ngOnInit(): void {
        if (this.isAdmin) {
            this.displayedColumns.push(...['createdBy', 'active', 'edit', 'delete']);
        }
        this.form = this.initializeForm();
        this.searchSubscriber();
        this.getSubService();
    }

    private initializeForm(): FormGroup {
        this.pageParams.pageSize = formConstant.pageSize;
        this.pageParams.pageIndex = 0;
        return new FormGroup({
            search: new FormControl(''),
        });

    }

    private searchSubscriber(): void {
        this.form.get('search').valueChanges.pipe(debounceTime(500))
            .subscribe(() => {
                this.getSubService();
            });
    }

    public get isAdmin(): boolean {
        return this.userSvc.isAdmin;
    }

    private getSubService(
        page: number = this.pageParams.pageIndex + 1 || 1,
        limit: number = this.pageParams.pageSize,
        q: string = this.form.get('search')?.value || '',
        orderField: string = this.currentSort?.active || '',
        orderDir: string = this.currentSort?.direction.toUpperCase() || '',
    ): void {
        const filter = {serviceId: this.serviceId};
        this.shipmentPriceSvc.get<IPaginatorProperties<ISubService>>('sub-service', page, limit, q, filter, orderField, orderDir)
            .subscribe((data) => {
                if (!data) {
                    return;
                }
                this.dataSource = new MatTableDataSource<ISubService>(data?.items);
                this.pageParams.pageSize = data?.meta?.itemsPerPage;
                this.pageParams.pageIndex = data?.meta?.currentPage - 1;
                this.pageParams.length = data?.meta?.totalItems;
            });
    }

    public openDialog(serviceDetail?: any): void {
        const dialogRef = this.dialog.open(ServiceComponent,
            {
                maxHeight: '800px',
                width: '640px',
            },
        );
        dialogRef.componentInstance.createMode = !serviceDetail;
        dialogRef.componentInstance.isSubService = true;
        dialogRef.componentInstance.serviceId = this.serviceId;
        dialogRef.componentInstance.service = !serviceDetail ? undefined : serviceDetail;
        dialogRef.componentInstance.title = !serviceDetail ? 'Add Sub Service' : 'Edit Sub Service';
        dialogRef.afterClosed()
            .subscribe((result) => {
                this.getSubService();
            });
    }

    public onStatusChange(event: { id: number; status: boolean }): void {
        this.showLoader = true;
        this.shipmentPriceSvc.updateSubServiceStatus(event.id, event.status, this.serviceId).subscribe((v) => {
            this.notify.showSuccessMessage(`Update successfully`);
            this.getSubService();
        }, (err) => {
            this.notify.showError(err.error.message);
            this.showLoader = false;
        });
    }

    public navigateTo(row): void {
        this.router.navigate([`/shipment-price/price-list`, {subServiceId: row.id}]);
    }

    public pageChanged(e: PageParams): void {
        this.pageParams.pageIndex = e.pageIndex;
        this.pageParams.pageSize = e.pageSize;
        this.getSubService();

    }

    public sortData(sort: Sort): void {
        this.currentSort = sort;
        this.getSubService();
    }

    public onDelete(id: number): void {
        this.showLoader = true;
        this.shipmentPriceSvc.delete('sub-service', id).subscribe((v) => {
            this.notify.showSuccessMessage(`Delete successfully`);
            this.getSubService();
        }, (err) => {
            this.notify.showError(err.error.message);
            this.showLoader = false;
        });
    }
}
